<template>
	<div class="aside-cms">
		<BaseCmsNav code="aside_cms" v-slot="{items, currentUrl}">
			<ul class="nav-sidebar">
				<li v-for="item in items" :key="item.id" :class="{'selected': currentUrl == item.url_without_domain}">
					<NuxtLink :to="item.url">
						{{ item.title }}
					</NuxtLink>
				</li>
			</ul>
		</BaseCmsNav>
		
		<ClientOnly>
			<div class="aside-info">
				<div class="footer-title"><BaseCmsLabel code="footer_col3_title" /><span class="toggle-icon"></span></div>
				<BaseCmsLabel code="footer_info" tag="div" />
			</div>
		</ClientOnly>
	</div>
</template>

<style lang="less" scoped>
	.footer-title{
		font-size: 22px; line-height: 1.2; padding-bottom: 10px; color: var(--primaryColor); font-weight: normal;
		.toggle-icon{display: none;}
		@media (max-width: @t){font-size: 18px; padding-bottom: 8px;}
		@media (max-width: @tp){
			font-size: 16px; padding: 15px 40px 15px 15px; position: relative;
			.toggle-icon{display: block; right: 15px; top: 19px; position: absolute;}
		}
	}
</style>
